import type { InputHTMLAttributes } from 'react';
import { useT } from '../app/i18n.tsx';

/**
 * A date field. On a phone the system draws the date in its own language ("1 Oct 2026" on an
 * English iPhone beside Polish labels), so there the day is written over the field in the app's
 * language, and a tap still opens the system's date picker. With a mouse the field is the browser's own.
 */
export function DateInput({ value, className, ...rest }: Omit<InputHTMLAttributes<HTMLInputElement>, 'type' | 'value'> & { value: string }) {
  const t = useT();
  return (
    <span className="date-input">
      <input {...rest} className={className ?? 'input'} type="date" value={value} />
      <span className="date-input__text" aria-hidden="true">
        {value ? t.date(value, 'medium') : ''}
      </span>
    </span>
  );
}
